export const transactionTypes = {
  'subscription-initiated': 'Initial Subscription',
  'scan-down': 'Scan Initial - {client: firstName lastName}',
  'scan-final': 'Scan Remainder - {client: firstName lastName}',
  'scan-down-refund': 'Scan Refund - {client: firstName lastName}',
  'extra-imprint': 'Additional Imprint Remedy - {client: firstName lastName}',
};

export const cardTypes = {
  'VISA': 'VISA',
  'MASTERCARD': 'MC',
  'DISCOVER': 'DSCR',
  'AMERICAN_EXPRESS': 'AMEX',
  'OTHER_BRAND': 'CARD'
}